var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"custom-class":"nav-tooltip","target":_vm.target,"triggers":_vm.triggers,"placement":_vm.placement}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }